import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icon/logo-white.svg'


const _hoisted_1 = {
  key: 0,
  slot: "fixed",
  class: "app-version"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_main_menu_divider = _resolveComponent("main-menu-divider")!
  const _component_main_menu_item = _resolveComponent("main-menu-item")!
  const _component_driver_menu = _resolveComponent("driver-menu")!
  const _component_site_manager_menu = _resolveComponent("site-manager-menu")!
  const _component_open_pdf_menu_item = _resolveComponent("open-pdf-menu-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!

  return (!_ctx.isWebApp)
    ? (_openBlock(), _createBlock(_component_ion_menu, {
        key: 0,
        contentId: "main-content",
        "menu-id": "burger",
        slide: "start",
        disabled: _ctx.disabled
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { color: "rockease" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, { onClick: _ctx.onCloseHamburgerClicked }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.closeOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_thumbnail, {
                    slot: "start",
                    class: "logo"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        alt: "logo",
                        class: "toolbar-logo",
                        src: _imports_0
                      }, null, -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("Rockease", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, {
                class: "menu ion-no-padding",
                mode: "md"
              }, {
                default: _withCtx(() => [
                  (_ctx.isLoggedIn)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.isUserNotValidated)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_main_menu_divider, {
                                label: _ctx.t('secondeVie.label')
                              }, null, 8, ["label"]),
                              _createVNode(_component_main_menu_item, {
                                icon: _ctx.sync,
                                label: _ctx.t('secondeVie.title'),
                                to: {name: _ctx.SiteManagerSecondeVieRoute}
                              }, null, 8, ["icon", "label", "to"])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.selectedRole === _ctx.ROLE_DRIVER)
                                ? (_openBlock(), _createBlock(_component_driver_menu, { key: 0 }))
                                : _createCommentVNode("", true),
                              (_ctx.selectedRole === _ctx.ROLE_SITE_MANAGER)
                                ? (_openBlock(), _createBlock(_component_site_manager_menu, { key: 1 }))
                                : _createCommentVNode("", true)
                            ], 64))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.items.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_main_menu_divider, { label: "Actions" }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                          return (_openBlock(), _createBlock(_component_main_menu_item, {
                            key: item.label,
                            icon: item.icon,
                            label: item.label,
                            onItemClick: item.click
                          }, null, 8, ["icon", "label", "onItemClick"]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.showDocuments && !_ctx.isUserNotValidated)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createVNode(_component_main_menu_divider, {
                          label: _ctx.t('documents.label')
                        }, null, 8, ["label"]),
                        _createVNode(_component_open_pdf_menu_item, {
                          href: _ctx.userGuideLink,
                          icon: _ctx.bookOutline,
                          label: _ctx.t('documents.userGuide')
                        }, null, 8, ["href", "icon", "label"]),
                        _createVNode(_component_open_pdf_menu_item, {
                          href: _ctx.transportReceiptLink,
                          icon: _ctx.receiptOutline,
                          label: _ctx.t('documents.transportReceipt')
                        }, null, 8, ["href", "icon", "label"])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_main_menu_divider, {
                    label: _ctx.t('others.label')
                  }, null, 8, ["label"]),
                  (_ctx.isLoggedIn)
                    ? (_openBlock(), _createBlock(_component_main_menu_item, {
                        key: 3,
                        icon: _ctx.cogOutline,
                        label: _ctx.t('others.parameters'),
                        onClick: _ctx.onParametersClicked
                      }, null, 8, ["icon", "label", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_main_menu_item, {
                    href: "mailto:support@rockease.fr",
                    icon: _ctx.mailOutline,
                    label: _ctx.t('others.contactSupport')
                  }, null, 8, ["icon", "label"]),
                  (_ctx.isLoggedIn)
                    ? (_openBlock(), _createBlock(_component_main_menu_item, {
                        key: 4,
                        icon: _ctx.logOutOutline,
                        label: _ctx.t('others.logout'),
                        onClick: _ctx.onLogOutClicked
                      }, null, 8, ["icon", "label", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.currentAppVersion)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, " v." + _toDisplayString(_ctx.currentAppVersion), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled"]))
    : _createCommentVNode("", true)
}